import type { FC } from 'react';
import { useTranslation } from 'react-i18next';
import TextButton from '@wix/da-ds/pkg/Buttons/TextButton';
import DrawIcon from '@wix/da-ds/pkg/Icons/24x24/Draw';
import { usePushMiniMuroModal } from '@wix/da-shared-react/pkg/utils/hooks/usePushMuroModal';
import { BiData, type EditWithMuroBiEvent } from '@wix/da-bi/pkg/events';

interface Props {}

const CreateWithDrawButton: FC<Props> = () => {
  const { t } = useTranslation();
  const pushMiniMuroModal = usePushMiniMuroModal();
  return (
    <TextButton
      variant="main"
      icon={DrawIcon}
      iconProps={{ branded: true }}
      size="large"
      onClick={pushMiniMuroModal}
      biData={BiData<EditWithMuroBiEvent>({
        evid: 926,
        sectionname: 'playground',
      })}
    >
      {t('studio.header.tabs.playground.cta.draw')}
    </TextButton>
  );
};

CreateWithDrawButton.displayName = 'CreateWithDrawButton';

export default CreateWithDrawButton;
